import React, { useEffect, useState } from "react";
import api from "../../services/api";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { FaRibbon, FaSearch, FaEdit, FaTrash, FaCheckCircle, FaClock, FaGift } from "react-icons/fa";

const MemorialProfilesDashboard = () => {
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const fetchProfiles = async () => {
    setLoading(true);
    try {
      const res = await api.get("/admin/profiles", {
        params: { page, pageSize, search },
      });
      setProfiles(res.data.items);
      setTotalCount(res.data.totalCount);
    } catch (err) {
      toast.error("Profilləri yükləmək mümkün olmadı!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfiles();
  }, [page, search]);

  const handleDelete = async (id) => {
    if (!window.confirm("Bu profili silmək istədiyinizə əminsiniz?")) return;
    try {
      await api.delete(`/admin/profiles/${id}`);
      toast.success("Profil uğurla silindi");
      fetchProfiles();
    } catch (err) {
      toast.error(err.response?.data?.message || "Silinmə uğursuz oldu");
    }
  };

  const handleConfirmMartyr = async (id) => {
    if (!window.confirm("Bu profili şəhid olaraq təsdiq etmək istəyirsiniz?")) return;
    try {
      await api.post(`/admin/profiles/${id}/confirm-martyr`);
      toast.success("Profil şəhid olaraq təsdiq olundu");
      fetchProfiles();
    } catch (err) {
      toast.error(err.response?.data?.message || "Təsdiqləmə uğursuz oldu");
    }
  };

  const handleConfirmWithoutPayment = async (id) => {
    if (!window.confirm("Bu profili ödənişsiz təsdiq etmək və yayımlamaq istəyirsiniz?")) return;
    try {
      await api.post(`/admin/profiles/${id}/confirm-without-payment`);
      toast.success("Profil ödənişsiz təsdiq olundu və yayımlandı!");
      fetchProfiles();
    } catch (err) {
      toast.error(err.response?.data?.message || "Təsdiqləmə uğursuz oldu");
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setSearch(searchInput);
    setPage(1);
  };

  const totalPages = Math.ceil(totalCount / pageSize);

  if (loading) {
    return (
      <div className="hy-profiles-loading">
        <div className="hy-profiles-spinner" />
        <p>Yüklənir...</p>
      </div>
    );
  }

  return (
    <div className="hy-profiles-container">
      <div className="hy-profiles-header">
        <div className="hy-profiles-title-section">
          <h2 className="hy-profiles-title">
            <FaRibbon /> Memorial Profillər
          </h2>
          <p className="hy-profiles-count">Ümumi: <strong>{totalCount}</strong> profil</p>
        </div>

        <form onSubmit={handleSearch} className="hy-profiles-search-form">
          <div className="hy-profiles-search-wrapper">
            <FaSearch className="hy-profiles-search-icon" />
            <input
              type="text"
              placeholder="Ad və ya soyad ilə axtar..."
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              className="hy-profiles-search-input"
            />
          </div>
          <button type="submit" className="hy-profiles-search-btn">
            Axtar
          </button>
        </form>
      </div>

      <div className="hy-profiles-table-wrapper">
        <table className="hy-profiles-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Ad Soyad</th>
              <th>Doğum / Vəfat</th>
              <th>Yaradan</th>
              <th>Yaradılma</th>
              <th>Status</th>
              <th>Təsdiq</th>
              <th>Əməliyyat</th>
            </tr>
          </thead>
          <tbody>
            {profiles.map((p, idx) => (
              <tr key={p.id}>
                <td className="hy-profiles-cell-number">{(page - 1) * pageSize + idx + 1}</td>
                <td className="hy-profiles-cell-name">
                  <div className="hy-profiles-name-wrapper">
                    {p.firstName} {p.lastName}
                    {p.isMartyr && <span className="hy-profiles-martyr-badge">Şəhid</span>}
                  </div>
                </td>
                <td className="hy-profiles-cell-date">
                  {new Date(p.dateOfBirth).toLocaleDateString("az-AZ")} –{" "}
                  {new Date(p.dateOfDeath).toLocaleDateString("az-AZ")}
                </td>
                <td className="hy-profiles-cell-creator">{p.createdByUserName || "-"}</td>
                <td className="hy-profiles-cell-created">
                  {new Date(p.createdAt).toLocaleDateString("az-AZ")}
                </td>
                <td>
                  {p.isConfirmed ? (
                    <span className="hy-profiles-status-confirmed">
                      <FaCheckCircle /> Təsdiqlənib
                    </span>
                  ) : (
                    <span className="hy-profiles-status-pending">
                      <FaClock /> Gözləyir
                    </span>
                  )}
                </td>
                <td>
                  {p.isConfirmed ? (
                    <span className="hy-profiles-confirmed-text">✓</span>
                  ) : p.isMartyr ? (
                    <button
                      onClick={() => handleConfirmMartyr(p.id)}
                      className="hy-profiles-btn-confirm-martyr"
                      title="Şəhid kimi təsdiqlə"
                    >
                      <FaCheckCircle /> Şəhid Təsdiqlə
                    </button>
                  ) : (
                    <button
                      onClick={() => handleConfirmWithoutPayment(p.id)}
                      className="hy-profiles-btn-confirm-free"
                      title="Ödənişsiz təsdiqlə"
                    >
                      <FaGift /> Ödənişsiz Təsdiqlə
                    </button>
                  )}
                </td>
                <td>
                  <div className="hy-profiles-actions">
                    <Link
                      to={`/dashboard/memorial-profiles/${p.id}/edit`}
                      className="hy-profiles-btn-edit"
                      title="Redaktə et"
                    >
                      <FaEdit />
                    </Link>
                    <button
                      onClick={() => handleDelete(p.id)}
                      className="hy-profiles-btn-delete"
                      title="Sil"
                    >
                      <FaTrash />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div className="hy-profiles-pagination">
          <button
            onClick={() => setPage(p => Math.max(1, p - 1))}
            disabled={page === 1}
            className="hy-profiles-pagination-arrow"
          >
            ← Əvvəlki
          </button>
          
          <div className="hy-profiles-pagination-numbers">
            {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
              let pageNum;
              if (totalPages <= 5) {
                pageNum = i + 1;
              } else if (page <= 3) {
                pageNum = i + 1;
              } else if (page >= totalPages - 2) {
                pageNum = totalPages - 4 + i;
              } else {
                pageNum = page - 2 + i;
              }
              
              return (
                <button
                  key={pageNum}
                  onClick={() => setPage(pageNum)}
                  className={`hy-profiles-pagination-btn ${page === pageNum ? 'active' : ''}`}
                >
                  {pageNum}
                </button>
              );
            })}
          </div>

          <button
            onClick={() => setPage(p => Math.min(totalPages, p + 1))}
            disabled={page === totalPages}
            className="hy-profiles-pagination-arrow"
          >
            Sonrakı →
          </button>
        </div>
      )}
    </div>
  );
};

export default MemorialProfilesDashboard;
